import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-underline',
  templateUrl: './underline.component.html',
  styleUrls: ['./underline.component.scss']
})
export class UnderlineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
